import { render, staticRenderFns } from "./competency-info-panel.vue?vue&type=template&id=7ba0d9ae&scoped=true"
import script from "./competency-info-panel.ts?vue&type=script&lang=ts&external"
export * from "./competency-info-panel.ts?vue&type=script&lang=ts&external"
import style0 from "./competency-info-panel.scss?vue&type=style&index=0&id=7ba0d9ae&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ba0d9ae",
  null
  
)

export default component.exports